// extracted by mini-css-extract-plugin
export var underlinedLink = "_p1-0";